import React from 'react';
import { IMaskInput } from 'react-imask';


export default class NumberInput extends React.Component {
    state = {

    }

    componentDidMount() {

    }

    handleFocus = (event) => {
        event.target.select();
    }

    render() {
        var type = this.props.type;
        var disabled = false;
        if (this.props.disabled !== undefined) {
            disabled = this.props.disabled;
        }
        var negative = false;
        if (this.props.negative !== undefined) {
            negative = this.props.negative;
        }
        switch (type) {
            case "Integer": {
                var className = this.props.className + " input-number";
                return (<IMaskInput
                    id={this.props.id}
                    mask={Number}
                    className={className}
                    radix="."
                    scale={0}
                    signed={negative}
                    value={this.props.value}
                    unmask={'typed'} // true|false|'typed'
                    // DO NOT USE onChange TO HANDLE CHANGES!
                    // USE onAccept INSTEAD
                    onFocus={this.handleFocus}
                    onAccept={
                        // depending on prop above first argument is
                        // `value` if `unmask=false`,
                        // `unmaskedValue` if `unmask=true`,
                        // `typedValue` if `unmask='typed'`
                        (typedValue, mask) => {
                            var event = {
                                target: {},
                            };
                            var input = mask.el.input;
                            console.log(event.target);
                            console.log(typedValue);
                            event.target.id = input.id;
                            event.target.name = input.name;
                            event.target.value = typedValue;
                            if (this.props.onChange !== undefined) {
                                this.props.onChange(event);
                            }
                        }
                    }
                    // ...and more mask props in a guide

                    // input props also available
                    placeholder={this.props.placeholder}
                    disabled={disabled}
                />);
            }
            case "Rate": {
                var className = this.props.className + " input-number";
                var defaultScale = 4;
                if (this.props.scale !== undefined) {
                    defaultScale = this.props.scale
                }
                var padFractional = true;
                if (defaultScale === 0) {
                    padFractional = false;
                }
                return (<IMaskInput
                    id={this.props.id}
                    mask={Number}
                    className={className}
                    radix="."
                    signed={negative}
                    mapToRadix={[","]}
                    scale={defaultScale}
                    padFractionalZeros={padFractional}
                    value={this.props.value}
                    unmask={'typed'} // true|false|'typed'
                    // DO NOT USE onChange TO HANDLE CHANGES!
                    // USE onAccept INSTEAD
                    onFocus={this.handleFocus}
                    onAccept={
                        // depending on prop above first argument is
                        // `value` if `unmask=false`,
                        // `unmaskedValue` if `unmask=true`,
                        // `typedValue` if `unmask='typed'`
                        (typedValue, mask) => {
                            var event = {
                                target: {},
                            };
                            var input = mask.el.input;
                            console.log(event.target);
                            console.log(typedValue);
                            event.target.id = input.id;
                            event.target.name = input.name;
                            event.target.value = typedValue;
                            if (this.props.onChange !== undefined) {
                                this.props.onChange(event);
                            }
                        }
                    }
                    // ...and more mask props in a guide

                    // input props also available
                    placeholder={this.props.placeholder}
                    disabled={disabled}
                />);
            }
            case "Currency": {
                var className = this.props.className + " input-number";
                var defaultScale = 2;
                if (this.props.scale !== undefined) {
                    defaultScale = this.props.scale
                }
                var padFractional = true;
                if (defaultScale === 0) {
                    padFractional = false;
                }

                return (<IMaskInput
                    id={this.props.id}
                    mask={Number}
                    className={className}
                    radix="."
                    thousandsSeparator=","
                    scale={defaultScale}
                    signed={negative}
                    padFractionalZeros={padFractional}
                    value={this.props.value}
                    unmask={'typed'} // true|false|'typed'
                    // DO NOT USE onChange TO HANDLE CHANGES!
                    // USE onAccept INSTEAD
                    onFocus={this.handleFocus}
                    onAccept={
                        // depending on prop above first argument is
                        // `value` if `unmask=false`,
                        // `unmaskedValue` if `unmask=true`,
                        // `typedValue` if `unmask='typed'`
                        (typedValue, mask) => {
                            var event = {
                                target: {},
                            };
                            var input = mask.el.input;
                            console.log(event.target);
                            console.log(typedValue);
                            event.target.id = input.id;
                            event.target.name = input.name;
                            event.target.value = typedValue;
                            if (this.props.onChange !== undefined) {
                                this.props.onChange(event);
                            }
                        }
                    }
                    // ...and more mask props in a guide

                    // input props also available
                    placeholder={this.props.placeholder}
                    disabled={disabled}
                />);
            }
            default:
                return (<div></div>);
        }
    }
}